
export default {
  download: {
    'documentTitle': 'Ruta ORS',
    'download': 'Descargar',
    'downloadFileName': 'Nombre del archivo a exportar',
    'downloadFormat': 'Formato para la exportación',
    'downloadRoute': 'Exportar ruta',
    'preparingDownload': 'Preparando el archivo ...',
    'fileReady': 'Archivo listo',
    'errorPreparingFile': 'Error al preparar el archivo',
    'fileTooBigToBeDownloaded': 'Archivo demasiado grande para descargar',
    'standard': 'Estándar'
  }
}
